import { UrbanFeatureType } from "@/types/gql/graphql";
import * as z from "zod";

export const urbanFeaturePointSchema = z.object({
  name: z.string().optional(),
  address: z.object({
    streetNumber: z.string().min(1, "Street number is required"),
    streetName: z.string().min(1, "Street name is required"),
    city: z.string().min(1, "City is required"),
    province: z.string().optional().nullable(),
    postalCode: z.string().min(1, "Postal code is required"),
    country: z.string().min(1, "Country is required"),
  }),
  type: z.enum(UrbanFeatureType),
});

export const urbanFeaturePolygonSchema = z.object({
  name: z.string().optional(),
  address: z.object({
    streetNumber: z.string().min(1, "Street number is required"),
    streetName: z.string().min(1, "Street name is required"),
    city: z.string().min(1, "City is required"),
    province: z.string().optional().nullable(),
    postalCode: z.string().min(1, "Postal code is required"),
    country: z.string().min(1, "Country is required"),
  }),
  type: z.enum(UrbanFeatureType),
  width: z.number().min(1, "Width must be at least 1"),
});

export type UrbanFeaturePointFormValues = z.infer<typeof urbanFeaturePointSchema>;
export type UrbanFeaturePolygonFormValues = z.infer<typeof urbanFeaturePolygonSchema>;
